export const QuickLink=[
    {id:1, title:'Medical Billing Service'},
    {id:2, title:'Medical Coding Service'},
    {id:3, title:'Medical Credentialing Service'},
    {id:4, title:'Front Office Management'}

];
export const CompanyInfo=[
    {id:1, title:'About Us'},
    {id:2, title:'Blog'},
    {id:3, title:'Contact'},
    {id:4, title:'Specialties'}

];
